export default {
  title: 'PayPal (suora)',
  description:
    'Yhdistä oma PayPal-yritystilisi vastaanottaaksesi PayPal-maksut suoraan omalla hinnoittelullasi. Luo REST-sovellus PayPal Developer Dashboardissa ja liitä sen Client ID ja Secret alla.',
  connected_description: 'PayPal-tilisi on yhdistetty. Maksut siirtyvät suoraan sinne.',
  guide: {
    title: 'Näin saat PayPal-tunnuksesi',
    step1: 'Kirjaudu PayPal Developer Dashboardiin PayPal-yritystililläsi.',
    step2: 'Avaa ”Apps & Credentials” ja luo sovellus (tai avaa olemassa oleva).',
    step3: 'Kopioi sovelluksen Client ID ja Secret.',
    step4: 'Liitä ne alle ja napsauta ”Connect PayPal”.',
    environment_note:
      'Käytä Live-tunnuksia oikeisiin maksuihin — vaihda Sandbox/Live-kytkintä ”Apps & Credentials” -sivun yläreunassa.',
    open_dashboard: 'Avaa PayPal Developer Dashboard',
  },
  status: {
    connected: 'Yhdistetty',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'PayPal REST -sovelluksesi Client ID',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'PayPal REST -sovelluksesi Secret',
    },
  },
  buttons: {
    connect: 'Yhdistä PayPal',
    disconnect: 'Katkaise yhteys',
  },
  toasts: {
    connected: 'PayPal yhdistetty onnistuneesti',
    connect_failed: 'PayPalia ei voitu yhdistää',
    disconnected: 'PayPal-yhteys katkaistu',
    disconnect_failed: 'PayPal-yhteyttä ei voitu katkaista',
  },
};
